import React, {Component} from 'react';
import {connect} from 'react-redux';
import {updateShoppingCartItem, deleteShoppingCartItem} from '../../redux/actions';

class CartListItem extends Component {
  constructor(props) {
      super(props);
      console.log(props)
      this.state = {
        previousOrderNumber: this.props.qty,
        currentInputNumber: this.props.qty
      }
  }

  getColorList = (color) => {
      const blockStyle = {
        margin: "0 5px",
        padding: "0",
        display: "inline-block",
        background: color,
        borderRadius: "5px",
        width: "20px",
        height: "20px",
        verticalAlign: "middle"
      }
      return <span key={color} className="singleItemColorBlock" style={blockStyle}></span>
  }

  onInputChange = (event) => {
    this.setState({
      currentInputNumber: event.target.value
    });

    const {userToken, color, flowerId} = this.props;
    const previousNumber = this.state.previousOrderNumber;
    const newNumber = event.target.value;

    if (previousNumber !== newNumber) {
      this.props.updateShoppingCartItem(userToken, flowerId, color, previousNumber, color, newNumber);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }

  onDeleteIconClicked = (event) => {
    const {userToken, color, flowerId} = this.props;
    const previousNumber = this.state.previousOrderNumber;
    this.props.deleteShoppingCartItem(userToken, flowerId, color, previousNumber);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  changeMouseCursor = () => {
    let deleteIcons = document.querySelectorAll('#deleteIcon');
    for (let i = 0; i < deleteIcons.length; i++) {
      deleteIcons[i].style.cursor = 'pointer';
    }
  }

  render(){
    return(
      <div className="CartListItem">
        <span
          id="deleteIcon"
          className="deleteIcon"
          onClick={this.onDeleteIconClicked}
          onMouseEnter={this.changeMouseCursor}>
          &#x2716;
        </span>

        <div className="CartListImg col-md-4">
          <img src={this.props.imgURL} alt={this.props.name} />
        </div>
        <div className="CartListDesc col-md-8">
          <div className="CartListLine1"><span> </span> {this.props.name}</div>
          <div className="CartListLine2">
            <span>${this.props.price}</span>
            <span>
              QTY
              <input
                className="itemQuantity form-control"
                name="itemQuantity"
                type='text'
                value={this.state.currentInputNumber}
                onChange={this.onInputChange} />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state){
  return({
    userToken: state.userToken
  });
}

export default connect(mapStateToProps, {updateShoppingCartItem, deleteShoppingCartItem})(CartListItem);



// WEBPACK FOOTER //
// ./src/components/orderPage1/cartListItem.js